import { render, staticRenderFns } from "./headTitle.vue?vue&type=template&id=45a3db0e&scoped=true"
import script from "./headTitle.vue?vue&type=script&lang=js"
export * from "./headTitle.vue?vue&type=script&lang=js"
import style0 from "./headTitle.vue?vue&type=style&index=0&id=45a3db0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a3db0e",
  null
  
)

export default component.exports